import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { Box, Button, Grid, Typography } from "@mui/material";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { MESSAGE_PROCESSING_DETAILS } from "../../../app/utils/constant";
import { useAppDispatch, useAppSelector } from "../../../app/store/configureStore";
import { DirectDebitMandate } from "../../../app/models/directDebit/directDebitMandate";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ProductEnum } from "../../../app/enums/productEnum";
import { getCurrencyIconByCode } from "../../../app/utils/util";
import { PaymentFrequencyEnum } from "../../../app/enums/paymentFrequencyEnum";
import { useReferenceData } from "../../../app/customHooks/useReferenceData";
import { ApiRequestStatus } from "../../../app/enums/apiRequestStatus";
import { getDirectDebitMandatesAsync } from "../../../app/slices/directDebitMandateSlice";
import { AppPathEnum } from "../../../app/enums/appPathEnum";

export function MyDirectDebits() {
    const history = useHistory();

    const { directDebitMandates, directDebitMandatesStatus } = useAppSelector(state => state.directDebit);
    const { products, subscriptionIntervalUnits, currencies } = useAppSelector(state => state.ReferenceData);

    const { staticDataStateStatus } = useReferenceData();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getDirectDebitMandatesAsync());
    }, [dispatch]);

    usePortalScreen(portalScreenContext('MyDirectDebits'), undefined, !((staticDataStateStatus === ApiRequestStatus.Pending
        || directDebitMandatesStatus === ApiRequestStatus.Pending)));

    if (staticDataStateStatus === ApiRequestStatus.Pending
        || directDebitMandatesStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>

                <Grid container rowSpacing={4}>

                    <Grid size={{ xs: 12 }}></Grid>

                    <Grid size={{ xs: 12 }}>
                        <Typography variant='h6'>Manage Direct Debits</Typography>
                    </Grid>

                    {directDebitMandates && directDebitMandates?.length > 0 &&
                        <>
                            <Grid size={{ xs: 2.5 }} className="wordWrap">
                                <b>Direct Debit Name</b>
                            </Grid>

                            <Grid size={{ xs: 4 }} className="wordWrap">
                                <b>Unique Mandate Reference</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} className="wordWrap">
                                <b>Frequency</b>
                            </Grid>

                            <Grid size={{ xs: 2 }} className="wordWrap">
                                <b>Amount</b>
                            </Grid>

                            <Grid size={{ xs: 1.5 }} className="wordWrap">

                            </Grid>

                            {directDebitMandates?.map((item: DirectDebitMandate) => (
                                <React.Fragment key={item.id}>
                                    <Grid size={{ xs: 2.5 }} className="wordWrap">
                                        {products?.find(x => x.id === item.basketProducts[0].productId)?.name}
                                    </Grid>

                                    <Grid size={{ xs: 4 }} className="wordWrap">
                                        {item.reference}
                                    </Grid>

                                    <Grid size={{ xs: 2 }} className="wordWrap">
                                        {item.intervalCount === -1 && "-"}
                                        {item.intervalCount !== -1 && ((item.intervalCount !== null && item.intervalCount === 3) ?
                                            PaymentFrequencyEnum.Quarterly :
                                            products?.find(x => x.id === item.basketProducts[0].productId)?.code === ProductEnum.FamAnnualMembership
                                                ? PaymentFrequencyEnum.Annual
                                                : `${subscriptionIntervalUnits?.find(x => x.id === item.intervalUnitId)?.code.toUpperCase() === PaymentFrequencyEnum.Year.toUpperCase()
                                                    ? PaymentFrequencyEnum.Annual : PaymentFrequencyEnum.Monthly}`)}
                                    </Grid>

                                    <Grid size={{ xs: 2 }} className="wordWrap">
                                        {products?.find(x => x.id === item.basketProducts[0].productId)?.code ===
                                            ProductEnum.FamAnnualMembership ? 'Membership Rate' :
                                            `${getCurrencyIconByCode(currencies?.find(x => x.id ===
                                                item.basketProducts[0].currencyId)?.code)}
                                             ${item.basketProducts[0].cost}`}
                                    </Grid>

                                    <Grid size={{ xs: 1.5 }} className="wordWrap">
                                        <Button variant="outlined" color="primary" onClick={portalAction(portalScreenContext('MyDirectDebits'), 'MyDirectDebits.onClick.push', () => {
                                            history.push(`${AppPathEnum.MANAGE_DIRECT_DEBIT}/${item.id}/${window.location.search}`);
                                        })}>
                                            Manage
                                        </Button>
                                    </Grid>

                                </React.Fragment>
                            ))}
                        </>}

                    {directDebitMandates?.length === 0 &&
                        <Grid size={{ xs: 12 }} className="wordWrap">
                            No direct debits found.
                        </Grid>
                    }
                </Grid>
            </Box>
        </>
    );
}
